import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/store";
import { useGetUserDetailsQuery } from "src/store/slices/client/client.api";
import { setIsUserFetching, setUserDetails } from "src/store/slices/client/client.slice";

export default function useGetUser() {
  const token = useSelector((state: RootState) => state.auth.token);
  const { data: userDetails, isFetching , error} = useGetUserDetailsQuery(token, { skip: !token });
  const dispatch = useDispatch();
  useEffect(() => {
    if (userDetails) {
      dispatch(setUserDetails(userDetails));
    }
    dispatch(setIsUserFetching(isFetching));
  }, [userDetails, isFetching]);
  return { isFetching, userDetails, error };
}
